module.exports = __webpack_public_path__ + "img/introducePageSex_show_three.cb817b23.jpg";